
import React, { useContext, useState} from "react";
import { graphql, useStaticQuery } from "gatsby";
import theme from '../theme.json'
import theme_site from '../theme_site.json'


const DataContext = React.createContext();
const LocaleUpdateContext = React.createContext();


export const useData = () => {
  return useContext(DataContext);
};

export const useLocaleUpdate = () => {
  return useContext(LocaleUpdateContext);
};

export const DataProvider = ({children}) => {

const data = useStaticQuery(graphql`
    {
      allWpPost {
        edges {
          node {
            title
            excerpt
            slug
            date
            id
            content
            featuredImage {
              node {
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
            categories {
              nodes {
                name
                slug
              }
            }
            tags {
              nodes {
                slug
                name
              }
            }
            author {
              node {
                name
              }
            }
          }
        }
      }

      allWpPage {
        edges {
          node {
            title
            content
            promotion {
              cta
              promotionText
              url
            }
            featuredImage {
              node {
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    
    }
  `);
  let [locale, setLocale] = useState("en");

  const useLocaleUpdate = (lang) => {
    setLocale(lang);
  };
  //console.log("locale",locale)
  const themeData = {
    styles: {...theme.styles},
    components: {...theme.components,...theme_site.components}
  }
 
  const sortedPosts = data.allWpPost.edges.sort((a, b) =>
    a.node.date < b.node.date ? 1 : -1
  );

  return (
    <DataContext.Provider value={{data,locale, themeData, sortedPosts}}>
            <LocaleUpdateContext.Provider value={useLocaleUpdate}>
        {children}
              </LocaleUpdateContext.Provider>
    </DataContext.Provider>
  );
};
